import axios from 'axios';

import EspecialidadSeleccionar from '../types/EspecialidadSeleccionar';


async function GuardarEspecialidadesPrestador(prmIdPrestador: number, prmEspecialidadesPrestador: EspecialidadSeleccionar[]) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_especialidades_prestador"
    
    // Transformo prmEspecialidadesPrestador a un objeto que tenga "id": y el valor pero solo de solo los ids

    const especialidadesIds = prmEspecialidadesPrestador.map(item => ({id: item.id}));

    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_prestador": prmIdPrestador,
            "especialidades": especialidadesIds
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarEspecialidadesPrestador;